
import {
  alertController,
  loadingController,
  toastController
} from "@ionic/vue";

export default {
  name: 'MessageService',
  data() {
    return {
    }
  },
  methods: {
    toast: function (title, message) {
      return this.presentToast({
        position: 'bottom',
        color: 'secondary',
        header: title,
        message: message,
        buttons: [
          {
            text: 'CLOSE',
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
            }
          }
        ]
      });
    },
    presentToast: async function(options) {
      const toast = await toastController.create(options);
      return toast.present();
    },
    async presentProgressIndicator(timeout = 2000) {
      const loading = await loadingController
        .create({
          cssClass: 'my-custom-class',
          message: 'Please wait...',
          duration: this.timeout,
        });

      await loading.present();

      setTimeout(function() {
        loading.dismiss()
      }, timeout);

      return loading;
    },
    confirmAction: async function (header, subHeader, message) {
      return new Promise( (resolve) => {
        alertController.create({
          cssClass: 'my-custom-class',
          header: header,
          subHeader: subHeader,
          message: message,
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              cssClass: 'secondary',
              handler: () => {
                console.log('Confirm Cancel: ');
                resolve(false);
              }
            }, {
              text: 'Confirm',
              handler: () => {
                console.log('Confirm Okay');
                resolve(true);
              }
            }
          ]
        }).then( alert => {
          alert.present();
        } );
      });
    }
  }
}
